// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "v1.4.1-1-g78d9920-dirty",
    "hash": "g78d9920",
    "distance": 1,
    "tag": "v1.4.1",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v1.4.1",
        "major": 1,
        "minor": 4,
        "patch": 1,
        "prerelease": [],
        "build": [],
        "version": "1.4.1"
    },
    "suffix": "1-g78d9920-dirty",
    "semverString": "1.4.1+1.g78d9920",
    "version": "1.4.2"
};
/* tslint:enable */
